module.exports = __webpack_public_path__ + "assets/images/project/united-states-desktop.jpg?v=54aa5ab2";